// loading-spinner.component.ts
import { Component, Input } from '@angular/core';
import {NgClass} from '@angular/common';

@Component({
  selector: 'app-loading-spinner',
  standalone: true,
  template: `
    <div class="flex items-center justify-center">
      <div
        [ngClass]="[
          sizeClasses[size], color
        ]"
        class="animate-spin rounded-full border-2 border-t-transparent"
        role="status"
        aria-label="loading">
      </div>
    </div>
  `,
  imports: [
    NgClass
  ]
})
export class LoadingSpinnerComponent {
  @Input() size: string = 'md';
  @Input() color = 'border-theme-primary-light';

  sizeClasses: Record<string, string> = {
    'sm': 'w-4 h-4',
    'sm-md': 'w-6 h-6',
    'md': 'w-8 h-8',
    'lg': 'w-12 h-12',
    'xl': 'w-16 h-16',
    '2xl': 'w-20 h-20',
  };
}
